/**
 * <ry-feature> + <ry-feature-grid>
 *
 * Feature card with icon + responsive grid.
 *
 * Usage:
 * <ry-feature-grid cols="3">
 *   <ry-feature icon="settings">
 *     <h3>Easy Setup</h3>
 *     <p>One line to get started.</p>
 *   </ry-feature>
 * </ry-feature-grid>
 */

import { RyElement } from '../core/ry-element.js';
import { getIcon } from '../core/ry-icons.js';

export class RyFeature extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="icon"]')) return;

    const iconName = this.getAttribute('icon');
    if (!iconName) return;

    const iconSvg = getIcon(iconName);
    if (!iconSvg) return;

    const iconDiv = document.createElement('div');
    iconDiv.setAttribute('data-ry-target', 'icon');
    iconDiv.className = 'ry-feature__icon';
    iconDiv.innerHTML = iconSvg;
    this.insertBefore(iconDiv, this.firstChild);
  }
}

export class RyFeatureGrid extends RyElement {}

customElements.define('ry-feature', RyFeature);
customElements.define('ry-feature-grid', RyFeatureGrid);
